import { Colors } from "../constants/Colors";

/**
 * PrimaryButton component - A styled button with customizable icon, click handler, and children.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.icon - Icon element displayed inside the button.
 * @param {() => void} props.onClick - Click handler function.
 * @param {React.ReactNode} props.children - Button text or elements.
 * @param {React.CSSProperties} [props.style] - Additional CSS styles for the button.
 *
 * @returns {JSX.Element} The PrimaryButton component.
 */
export const PrimaryButton = ({ icon, onClick, children, style }) => {
  return (
    <button
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 20px",
        borderRadius: "10px",
        backgroundColor: Colors.primary100,
        color: Colors.white,
        fontWeight: "bold",
        ...style,
      }}
      onClick={onClick}
    >
      {icon && <div>{icon}</div>}
      <div style={{ flexGrow: "1" }}>{children}</div>
    </button>
  );
};

/**
 * Secondary component - A styled button with customizable icon, click handler, and children.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.icon - Icon element displayed inside the button.
 * @param {() => void} props.onClick - Click handler function.
 * @param {React.ReactNode} props.children - Button text or elements.
 * @param {React.CSSProperties} [props.style] - Additional CSS styles for the button.
 *
 * @returns {JSX.Element} The Secondary component.
 */
export const SecondaryButton = ({ icon, onClick, children, style }) => {
  return (
    <button
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        padding: "10px 20px",
        border: "1px solid rgb(84, 93, 101)",
        borderRadius: "10px",
        backgroundColor: Colors.white,
        color: "rgb(84, 93, 101)",
        fontWeight: "bold",
        ...style,
      }}
      onClick={onClick}
    >
      {icon && <div>{icon}</div>}
      <div style={{ flexGrow: "1" }}>{children}</div>
    </button>
  );
};
